import { render, staticRenderFns } from "./PendingVideos.vue?vue&type=template&id=7c52ca0e&scoped=true"
import script from "./PendingVideos.vue?vue&type=script&lang=js"
export * from "./PendingVideos.vue?vue&type=script&lang=js"
import style0 from "./PendingVideos.vue?vue&type=style&index=0&id=7c52ca0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c52ca0e",
  null
  
)

export default component.exports